import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-daisyui';
import BrandCardSideContent from '@/components/ui/BrandCardSideContent/BrandCardSideContent.tsx';
import Routes from '@/router/Routes.ts';

const PasswordChangedConfirmationPage: FC = () => {
  return (
    <BrandCardSideContent>
      <div className="w-[428px] max-w-full flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h2 className="font-bold text-2xl">Password changed</h2>
          <p className="text-text-secondary">Your password has been successfully changed. You can now log in with your new password.</p>
        </div>
        <Link to={Routes.LOGIN}>
          <Button color="primary" className="w-full">
            Go to login
          </Button>
        </Link>
      </div>
    </BrandCardSideContent>
  );
};

export default PasswordChangedConfirmationPage;
